<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      resizable
      border
      size="small"
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="400"
      ref="goodsSpecTable"
      row-id="shipmentHscodeGoodsSpecCode"
      :checkbox-config="{ highlight: true }"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      @edit-closed="onEditClosed"
      :edit-rules="validRules"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
      <template v-slot:hscode="{ row }">
        <HscodeSelect
          :hscode="row.hscode"
          :categoryCode="masterCategoryCode"
          size="mini"
          @change="(val) => onHscodeChange({ row, val })"
        ></HscodeSelect>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import HscodeSelect from '../../hscode-select'
import tableColumns from './table-columns'
import { multiply, divideRound } from '@/libs/util.number.js'
export default {
  components: { HscodeSelect },
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    currencyUnit: { type: String, default: '' },
    salesCurrencyUnit: { type: String, default: '' },
    masterCategoryCode: { type: String, default: '' },
    disabledHsCode: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    reloadColumn() {
      return {
        disabledHsCode: this.disabledHsCode,
        currencyUnit: this.currencyUnit,
        salesCurrencyUnit: this.salesCurrencyUnit,
      }
    },
    validRules() {
      return {
        hscode: [
          {
            required: !this.disabledHsCode,
            message:
              this.$l('INDEX.form_placeholder_hscode') || '请选择报关HSCODE',
          },
          {
            validator: ({ cellValue }) => {
              return new Promise((resolve, reject) => {
                if (this.disabledHsCode) {
                  resolve()
                } else if (!cellValue) {
                  reject(
                    new Error(
                      this.$l('INDEX.form_placeholder_hscode') ||
                        '请选择报关HSCODE'
                    )
                  )
                } else {
                  resolve()
                }
              })
            },
          },
        ],
      }
    },
  },
  watch: {
    reloadColumn: {
      handler() {
        const $goodsSpecTable = this.$refs.goodsSpecTable
        if ($goodsSpecTable) $goodsSpecTable.reloadColumn(tableColumns(this))
        this.onCheckboxChange({})
      },
      immediate: true,
      deep: true,
    },
    tableData: {
      handler(e) {
        this.$emit('change', e)
      },
      deep: true,
    },
  },
  methods: {
    onCheckboxChange({ records = [] }) {
      this.$emit('checkboxChange', records)
    },
    onHscodeChange({ row, val }) {
      const { hscode, hscodeName, hscodeNameEn } = val || {}
      row.hscode = hscode
      row.hscodeName = hscodeName
      row.hscodeNameEn = hscodeNameEn
    },
    async validate() {
      return !(await this.$refs.goodsSpecTable.validate(true))
    },
    getTableData() {
      const { fullData } = this.$refs.goodsSpecTable.getTableData()
      return fullData
    },
    onEditClosed({ row }) {
      const {
        inGroupQty,
        goodsSpecLength,
        goodsSpecWidth,
        goodsSpecWeight,
        goodsSpecPrice,
        goodsSpecSalePrice,
      } = row

      row.goodsSpecArea = divideRound(multiply(goodsSpecLength, goodsSpecWidth), 10000)

      const totalGoodsSpecWeight = multiply(inGroupQty, goodsSpecWeight)
      const totalGoodsSpecPrice = multiply(inGroupQty, goodsSpecPrice)
      const totalGoodsSpecSalePrice = multiply(inGroupQty, goodsSpecSalePrice)
      row.totalGoodsSpecWeight = totalGoodsSpecWeight
      row.v_totalGoodsSpecWeight = totalGoodsSpecWeight.toLocaleString()
      row.totalGoodsSpecPrice = totalGoodsSpecPrice
      row.v_totalGoodsSpecPrice = totalGoodsSpecPrice.toLocaleString()
      row.totalGoodsSpecSalePrice = totalGoodsSpecSalePrice
      row.v_totalGoodsSpecSalePrice = totalGoodsSpecSalePrice.toLocaleString()
    },
    setHscode({ hscode, hscodeName, hscodeNameEn, listCode = [] }) {
      const data = this.getTableData()
      data.forEach((item) => {
        if (
          !listCode ||
          !listCode.length ||
          listCode.includes(item.orderGoodsSpecCode)
        ) {
          item.hscode = hscode
          item.hscodeName = hscodeName
          item.hscodeNameEn = hscodeNameEn
        }
      })
      this.$refs.goodsSpecTable.reloadData(data)
    },
  },
}
</script>
